<template>
  <b-col
    cols="12"
    lg="4"
    xl="4"
  >
    <b-row
      class="d-none d-lg-none d-lg-flex"
      :style="{
        position: section ? 'relative' : 'fixed',
        height: section ? '100%' : 'calc(100vh - 100px)',
      }"
    >
      <!-- <b-col cols="12" class="ml-4 mt-2">
        <b-button
          v-if="!hide"
          class="back-btn"
          size="lg"
          @click="backButton"
          variant="link"
          style="min-width: inherit"
          ><img src="@/assets/images/small_back_arrow.svg"
        /></b-button>
      </b-col> -->
      <b-col
        cols="12"
        class="pl-5 ml-6"
      >
        <b-row
          align-h="center"
          :style="{ height: section ? 'auto' : 'calc(100vh - 230px)' }"
        >
          <b-col
            cols="12"
            align-self="start"
          >
            <template v-if="!isOnboardingRedesign">
              <h3
                v-show="!hideStep"
                class="onboarding-title d-letter-spacing mt-6"
              >
                {{ title }}
              </h3>
            </template>
          </b-col>
          <b-col
            cols="12"
            align-self="end"
            class="mb-3"
          >
            <template v-if="!section">
              <h6
                v-if="step"
                class="step d-letter-spacing"
              >
                <!-- Step {{ step }} of 4 -->
              </h6>
            </template>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- mobile view -->
    <portal to="back">
      <template v-if="isOnboardingRedesign">
        <b-button
          v-if="!hide"
          class="back-btn tw-mr-4"
          size="lg"
          variant="link"
          style="min-width: inherit"
          @click="backButton"
        >
          <!-- Back icon -->
          <svg
            width="19"
            height="15"
            viewBox="0 0 19 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.25 7.58594C0.25 7.32149 0.365476 7.08816 0.596428 6.88594L6.9806 0.877604C7.19506 0.68316 7.43839 0.585938 7.71058 0.585938C7.98277 0.585938 8.2096 0.671493 8.39106 0.842604C8.58077 1.01372 8.67563 1.23149 8.67563 1.49594C8.67563 1.62038 8.65088 1.74094 8.60139 1.8576C8.56015 1.97427 8.49417 2.07149 8.40343 2.14927L6.69604 3.8176L2.51416 7.37594L2.29145 6.8626L5.58252 6.64094H17.2621C17.559 6.64094 17.7982 6.73038 17.9797 6.90927C18.1612 7.08816 18.2519 7.31372 18.2519 7.58594C18.2519 7.85816 18.1612 8.08372 17.9797 8.2626C17.7982 8.44149 17.559 8.53094 17.2621 8.53094H5.58252L2.29145 8.30927L2.51416 7.8076L6.69604 11.3543L8.40343 13.0226C8.49417 13.1004 8.56015 13.1976 8.60139 13.3143C8.65088 13.4309 8.67563 13.5515 8.67563 13.6759C8.67563 13.9404 8.58077 14.1582 8.39106 14.3293C8.2096 14.5004 7.98277 14.5859 7.71058 14.5859C7.43839 14.5859 7.19506 14.4887 6.9806 14.2943L0.596428 8.28594C0.365476 8.08372 0.25 7.85038 0.25 7.58594Z"
              fill="#19191C"
            />
          </svg>
        </b-button>
      </template>
      <template v-else>
        <b-navbar
          v-if="!hide"
          :class="{
            'd-lg-none sidenav tw-z-[50] tw-relative !tw-top-0': true,
            [$_fsaHsaPromo_isActiveFsaHsaPromo && !hide && FSAtopStyle ]: true,

          }"
        >
          <b-container fluid>
            <b-row
              align-v="center"
              style="width: 100%"
            >
              <b-col cols="3">
                <template>
                  <b-button
                    class="back-btn"
                    size="lg"
                    variant="link"
                    style="min-width: inherit"
                    @click="backButton"
                  >
                    <img
                      src="@/assets/images/small_back_arrow.svg"
                    >
                  </b-button>
                </template>
              </b-col>
            </b-row>
          </b-container>
        </b-navbar>
      </template>
    </portal>
  </b-col>
</template>

<script>
import { mapState } from 'vuex';
import { fsaHsaPromoMixin } from '@/mixins/fsaHsaPromo';

export default {
  mixins: [fsaHsaPromoMixin],
  props: {
    title: {
      type: String,
    },
    step: {
      type: String,
    },
    hide: {
      type: Boolean,
    },
    hideStep: {
      type: Boolean,
      default: false,
    },
    section: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState('global', ['isOnboardingRedesign']),
    FSAtopStyle() {
      const path = this.$route.path;

      if (path === '/eligibility') {
        return 'tw-top-[6.5rem] md:tw-top-[7.75rem]'
      }
      if (path === '/health-questions' || path === '/treatment-options' || path === '/identity-verification' || path === '/checkout') {
        return 'tw-top-[7.375rem] md:tw-top-[9.17rem]'
      }

      return ''
    },
    defaultTopStyle() {
      const path = this.$route.path;

      if (path === '/eligibility') {
        return 'tw-top-[44px]'
      }
      return 'tw-top-[60px]'
    },
  },
  methods: {
    backButton(event) {
      this.$emit('back', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.back-btn {
  @include media-breakpoint-up(xxl) {
    img {
      width: 25px * $scale-font;
      height: 13px * $scale-font;
    }
  }
}
</style>
